/**
 * Created by
 */

var window = require("../../../support/window.js")

    // 获取URL参数
var getUrlParmar = function(name) {
        var re = new RegExp("[\\?\\&]"+name+"=([^\\?\\&]*)", "ig");
        var r = "";
        while (r = re.exec(window.location.href)) {
            var val = r[1];
            return val;
        }
    };


module.exports = {
    getUrlParmar : getUrlParmar
}




//////////////////
// WEBPACK FOOTER
// ./src/main/javascript/func/fdapi/commons/commons.js
// module id = 15
// module chunks = 0